import TextInput from "components/inputs/text-input";
import ModalTemplate from "components/modal/modal-template";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Dropdown from "components/inputs/dropdown";
import { StoreIconName, storeIcons } from "constants/storeIcons";
import { isValidUrl } from "utils/isValidUrl";

interface IProps {
  addedLinks: string[];
  close: () => void;
  save: (link: { url: string; name: string }) => void;
  editData?: { url: string; name: string };
  saveEdit?: (link: { url: string; name: string }) => void;
}
const AddTrackLink = ({
  close,
  save,
  editData,
  saveEdit,
  addedLinks
}: IProps) => {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");

  const disableConfirm = useMemo(() => {
    if (name.length === 0 || !isValidUrl(url)) {
      return true;
    }
    return false;
  }, [url, name]);

  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setUrl(editData.url);
    }
  }, [editData]);

  return (
    <ModalTemplate
      close={close}
      header="Track Links"
      twoButtons
      confirmText="Save"
      cancelText="Cancel"
      disableConfirm={disableConfirm}
      confirm={() => {
        if (editData && saveEdit) {
          saveEdit({ name, url });
        } else {
          save({ name, url });
        }

        setName("");
        setUrl("");
      }}
    >
      <Dropdown
        placeholder="Select Platform"
        label="Platform"
        chosenItem={name.charAt(0).toUpperCase() + name.slice(1)}
        items={
          Object.keys(storeIcons).filter(
            (link) =>
              !addedLinks
                ?.map((item) => item.toLowerCase())
                .includes(link.toLowerCase())
          ) as StoreIconName[]
        }
        selectItem={(val) => setName(val as StoreIconName)}
      />
      <Gap />
      <TextInput
        label="URL"
        placeholder="https://"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
      />
      {/* <Gap />
      <Typography weight="semibold" color={Colors.grey400} mb="0.8rem">
        Platform Logo
      </Typography>
      <ImageContainer>
        {!logo ? (
          <DragNDrop
            setFile={(file) => setLogo(file)}
            subheader={false}
            limit={5000}
          />
        ) : (
          <>
            <CancelIcon onClick={() => setLogo(undefined)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 12 12"
                fill="none"
              >
                <circle cx="6.00014" cy="5.9999" r="2.57143" fill="#1E1E1E" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.001 6C11.001 8.7614 8.76238 11 6.00098 11C3.23955 11 1.00098 8.7614 1.00098 6C1.00098 3.23857 3.23955 1 6.00098 1C8.76238 1 11.001 3.23857 11.001 6ZM4.48579 4.48483C4.63224 4.33838 4.86967 4.33838 5.01613 4.48483L6.00098 5.46965L6.98578 4.48484C7.13223 4.33839 7.36968 4.33839 7.51613 4.48484C7.66258 4.63128 7.66258 4.86872 7.51613 5.01515L6.53128 6L7.51613 6.9848C7.66258 7.13125 7.66258 7.3687 7.51613 7.51515C7.36968 7.6616 7.13223 7.6616 6.98578 7.51515L6.00098 6.53035L5.01613 7.51515C4.86969 7.6616 4.63225 7.6616 4.4858 7.51515C4.33936 7.3687 4.33936 7.13125 4.4858 6.98485L5.47063 6L4.48579 5.01515C4.33934 4.86871 4.33934 4.63127 4.48579 4.48483Z"
                  fill="#CDCDCD"
                />
              </svg>
            </CancelIcon>
            <LogoImage src={URL.createObjectURL(logo)} alt={name} />
          </>
        )}
      </ImageContainer>
      <Typography size="xs" color={Colors.grey400} ml="1">
        .png, .svg, .jpg file{" "}
      </Typography> */}
    </ModalTemplate>
  );
};

export default AddTrackLink;

const Gap = styled.div`
  height: 1.6rem;
  width: 40rem;
`;

const ImageContainer = styled.div`
  width: 10rem;
  height: 10rem;
  margin-bottom: 0.8rem;
  position: relative;
`;

const LogoImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  border-radius: 0.4rem;
`;

const CancelIcon = styled.div`
  position: absolute;
  width: 1.4rem;
  height: 1.4rem;
  top: -0.7rem;
  right: -0.7rem;
  cursor: pointer;
`;
